import { Tabs } from "antd";
import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import { useState, useEffect } from "react";
import axios from "axios";
import { format } from "path";

const MatcherHotel = () => {
    const [activeTab, setActiveTab] = useState<TabKey>("1");
    const [rowData, setRowData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const items = [
        {
            key: "1",
            label: "Matched",
        },
        {
            key: "2",
            label: "Unmatched",
        },
        {
            key: "3",
            label: "Manual Review",
        },
    ];

    type TabKey = "1" | "2" | "3";

    const API_MAP: Record<TabKey, { url: string; key: string }> = {
        "1": { url: "https://stage-apiplatform.finkraftai.com/api/hotelMatcher/matched", key: "matchedData" },
        "2": { url: "https://stage-apiplatform.finkraftai.com/api/hotelMatcher/unmatched", key: "unmatchedData" },
        "3": { url: "https://stage-apiplatform.finkraftai.com/api/hotelMatcher/manual", key: "manualData" },
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const { url } = API_MAP[activeTab];
                const response = await axios.get(url);

                console.log("Full API response:", response.data);
                const apiData =
                    response.data?.data?.matchedData ??
                    response.data?.data?.unMatchedData ??
                    response.data?.data?.manualData ??
                    [];

                console.log("Processed data:", apiData);

                setRowData(apiData);
            } catch (error) {
                console.error("Error fetching API:", error);
                setRowData([]);
            } finally {
                setLoading(false);
            }
        };

        if (activeTab) fetchData();
    }, [activeTab]);


    const MATCHED_COLUMN_DEFS = [
        {
            headerName: "Invoice Number",
            field: "invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Parsed Invoice Number",
            field: "parsed_invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Workspace",
            field: "workspace",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Client GST Number",
            field: "client_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Hotel GST Number",
            field: "hotel_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Asset Link",
            field: "asset_link",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) =>
                params.value ? (
                    <a href={params.value} target="_blank" rel="noopener noreferrer">
                        View
                    </a>
                ) : (
                    ""
                ),
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Checkout Date",
            field: "checkout_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Total GST Amount 1",
            field: "total_gst_amount_1",
            filter: "agNumberColumnFilter",
            enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Total GST Amount 2",
            field: "total_gst_amount_2",
            filter: "agNumberColumnFilter",
            enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Created On",
            field: "created_on",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Reason",
            field: "reason",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Matched By",
            field: "matched_by",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
    ];


    const UNMATCHED_COLUMN_DEFS = [
        {
            headerName: "Hotel GSTIN",
            field: "hotel_gstin",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Client GSTIN",
            field: "client_gstin",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Invoice Number",
            field: "invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "GST Amount",
            field: "gst_amount",
            filter: "agNumberColumnFilter",
            enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Checkout Date",
            field: "checkout_date",
            filter: "agDateColumnFilter",
           filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); // parse from backend format
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Asset Link",
            field: "asset_link",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) =>
                params.value ? (
                    <a href={params.value} target="_blank" rel="noopener noreferrer">
                        View
                    </a>
                ) : (
                    ""
                ),
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Created On",
            field: "created_on",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Matched By",
            field: "matched_by",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
    ];



    const MANUAL_COLUMN_DEFS = [
        {
            headerName: "Invoice Number",
            field: "invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Parsed Invoice Number",
            field: "parsed_invoice_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Workspace",
            field: "workspace",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Client GST Number",
            field: "client_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Hotel GST Number",
            field: "hotel_gst_number",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Asset Link",
            field: "asset_link",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) =>
                params.value ? (
                    <a href={params.value} target="_blank" rel="noopener noreferrer">
                        View
                    </a>
                ) : null,
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Checkout Date",
            field: "checkout_date",
            filter: "agDateColumnFilter",
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Total GST Amount 1",
            field: "total_gst_amount_1",
            filter: "agNumberColumnFilter",
             enableValue: true,
            formatType: "AMOUNT"
        },
        {
            headerName: "Total GST Amount 2",
            field: "total_gst_amount_2",
            filter: "agNumberColumnFilter",
             enableValue: true,
             formatType: "AMOUNT"
        },
        {
            headerName: "AI Score",
            field: "ai_score",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "AI Confidence",
            field: "ai_confidence",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Remark",
            field: "remark",
            filter: "agTextColumnFilter",
            editable: true, 
            enableRowGroup: true,
            enablePivot: true
        },
        {
            headerName: "Created On",
            field: "created_on",
            filter: "agDateColumnFilter",
            enableRowGroup: true,
            enablePivot: true,
            filterParams: {
                comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue); 
                    // Strip time part to compare only dates
                    const cellDateNoTime = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );
                    if (cellDateNoTime.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0;
                    }
                    return cellDateNoTime < filterLocalDateAtMidnight ? -1 : 1;
                },
            },
            valueFormatter: (params: any) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                // format as DD/MM/YYYY for display
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            headerName: "Matched By",
            field: "matched_by",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true
        },
    ];



    const getColumnDefs = () => {
        switch (activeTab) {
            case "1":
                return MATCHED_COLUMN_DEFS;
            case "2":
                return UNMATCHED_COLUMN_DEFS;
            case "3":
                return MANUAL_COLUMN_DEFS;
            default:
                return [];
        }
    };



    return (
        <div style={{height:"100%", display:'flex', flexDirection:"column"}}>
            <PageHeader
                leftActions={
                    <Tabs
                        items={items}
                        tabBarStyle={{
                            borderBottom: "none", // Remove the underline border
                            margin: 0,
                        }}
                        activeKey={activeTab}
                        onChange={(tabItem: string) => setActiveTab(tabItem as TabKey)}

                    />
                }
            />
            <div style={{ flex:1 }}>
                <AgTableClient
                    //@ts-ignore
                    columnDefs={getColumnDefs()}
                    rowData={rowData}
                    groupPanel
                    defaultPivot={[""]}
                    grandTotalRow
                    enablePDFViewer
                     showExport
                   pinnedBottomRowData
                />
            </div>
        </div>
    );
};

export default MatcherHotel;
